import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import TandaDetail from './pages/TandaDetail';
import CreateTanda from './pages/CreateTanda';
import Profile from './pages/Profile';
import AdminAudit from './pages/AdminAudit';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center p-20">Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Landing />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
            <Route path="profile" element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } />
            <Route path="tandas/:id" element={
              <PrivateRoute>
                <TandaDetail />
              </PrivateRoute>
            } />
            <Route path="admin/create-tanda" element={
              <PrivateRoute>
                <CreateTanda />
              </PrivateRoute>
            } />
            <Route path="admin/edit-tanda/:id" element={
              <PrivateRoute>
                <CreateTanda />
              </PrivateRoute>
            } />
            <Route path="admin/audit" element={
              <PrivateRoute>
                <AdminAudit />
              </PrivateRoute>
            } />
          </Route>
        </Routes>
      </AuthProvider>
    </Router>
  );
}
